import { PeriwinkleCard } from "./periwinkle-card";

interface ConnectLevelThumbnailProps {
  levelIndex: number;
  questionText?: string;
  size?: "sm" | "md";
}

const SIZES = {
  sm: {
    card: "h-12 w-12 flex-shrink-0 rounded-md p-1.5",
    title: "text-[11px]",
    body: "text-[9px]",
  },
  md: {
    card: "h-20 w-20 flex-shrink-0 rounded-lg p-2.5",
    title: "text-base",
    body: "text-[10px]",
  },
} as const;

export function ConnectLevelThumbnail({
  levelIndex,
  questionText,
  size = "sm",
}: ConnectLevelThumbnailProps) {
  const s = SIZES[size];
  return (
    <PeriwinkleCard variant="highlight" className={s.card} fullBleedOverlay>
      <div className="flex h-full flex-col justify-between">
        <span className={`font-mono font-semibold text-white ${s.title}`}>
          {`0${levelIndex + 1}`}
        </span>
        {questionText && (
          <p
            className={`line-clamp-2 font-bold leading-[1.1] text-white ${s.body}`}
          >
            {questionText}
          </p>
        )}
      </div>
    </PeriwinkleCard>
  );
}
